import { render, staticRenderFns } from "./TableLoading.vue?vue&type=template&id=28aa5cbc"
import script from "./TableLoading.vue?vue&type=script&lang=js"
export * from "./TableLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports